import { render } from "./BomValidationResultsElementsInfo.vue?vue&type=template&id=59c64d46&scoped=true"
import script from "./BomValidationResultsElementsInfo.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsInfo.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsInfo.vue?vue&type=style&index=0&id=59c64d46&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c64d46"]])

export default __exports__